/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  FeatureFlagApiResource,
  FeatureFlagUpdateRequest,
  GetApiFeatureFlagList200,
  GetApiFeatureFlagListParams,
  GetApiFeatureFlagWorkedPropertyList200,
  GetApiFeatureFlagWorkedPropertyListParams,
  NotFoundErrorResponse,
  UnauthorizedErrorResponse,
  UpdateWorkedPropertiesRequest,
  WorkedPropertyApiResource
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiFeatureFlagGetResponse200 = {
  data: FeatureFlagApiResource
  status: 200
}

export type getApiFeatureFlagGetResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiFeatureFlagGetResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiFeatureFlagGetResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiFeatureFlagGetResponseSuccess = (getApiFeatureFlagGetResponse200) & {
  headers: Headers;
};
export type getApiFeatureFlagGetResponseError = (getApiFeatureFlagGetResponse401 | getApiFeatureFlagGetResponse403 | getApiFeatureFlagGetResponse404) & {
  headers: Headers;
};

export type getApiFeatureFlagGetResponse = (getApiFeatureFlagGetResponseSuccess | getApiFeatureFlagGetResponseError)

export const getGetApiFeatureFlagGetUrl = (id: string,) => {


  

  return `/api/feature-flags/${id}`
}

export const getApiFeatureFlagGet = async (id: string, options?: RequestInit): Promise<getApiFeatureFlagGetResponse> => {
  
  return customFetch<getApiFeatureFlagGetResponse>(getGetApiFeatureFlagGetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type putApiFeatureFlagUpdateResponse200 = {
  data: FeatureFlagApiResource
  status: 200
}

export type putApiFeatureFlagUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiFeatureFlagUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiFeatureFlagUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiFeatureFlagUpdateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type putApiFeatureFlagUpdateResponseSuccess = (putApiFeatureFlagUpdateResponse200) & {
  headers: Headers;
};
export type putApiFeatureFlagUpdateResponseError = (putApiFeatureFlagUpdateResponse400 | putApiFeatureFlagUpdateResponse401 | putApiFeatureFlagUpdateResponse403 | putApiFeatureFlagUpdateResponse404) & {
  headers: Headers;
};

export type putApiFeatureFlagUpdateResponse = (putApiFeatureFlagUpdateResponseSuccess | putApiFeatureFlagUpdateResponseError)

export const getPutApiFeatureFlagUpdateUrl = (id: string,) => {


  

  return `/api/feature-flags/${id}`
}

export const putApiFeatureFlagUpdate = async (id: string,
    featureFlagUpdateRequest: FeatureFlagUpdateRequest, options?: RequestInit): Promise<putApiFeatureFlagUpdateResponse> => {
  
  return customFetch<putApiFeatureFlagUpdateResponse>(getPutApiFeatureFlagUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      featureFlagUpdateRequest,)
  }
);}


export type getApiFeatureFlagListResponse200 = {
  data: GetApiFeatureFlagList200
  status: 200
}

export type getApiFeatureFlagListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiFeatureFlagListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiFeatureFlagListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiFeatureFlagListResponseSuccess = (getApiFeatureFlagListResponse200) & {
  headers: Headers;
};
export type getApiFeatureFlagListResponseError = (getApiFeatureFlagListResponse400 | getApiFeatureFlagListResponse401 | getApiFeatureFlagListResponse403) & {
  headers: Headers;
};

export type getApiFeatureFlagListResponse = (getApiFeatureFlagListResponseSuccess | getApiFeatureFlagListResponseError)

export const getGetApiFeatureFlagListUrl = (params?: GetApiFeatureFlagListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["keys[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/feature-flags?${stringifiedParams}` : `/api/feature-flags`
}

export const getApiFeatureFlagList = async (params?: GetApiFeatureFlagListParams, options?: RequestInit): Promise<getApiFeatureFlagListResponse> => {
  
  return customFetch<getApiFeatureFlagListResponse>(getGetApiFeatureFlagListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiFeatureFlagWorkedPropertyListResponse200 = {
  data: GetApiFeatureFlagWorkedPropertyList200
  status: 200
}

export type getApiFeatureFlagWorkedPropertyListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiFeatureFlagWorkedPropertyListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiFeatureFlagWorkedPropertyListResponseSuccess = (getApiFeatureFlagWorkedPropertyListResponse200) & {
  headers: Headers;
};
export type getApiFeatureFlagWorkedPropertyListResponseError = (getApiFeatureFlagWorkedPropertyListResponse401 | getApiFeatureFlagWorkedPropertyListResponse403) & {
  headers: Headers;
};

export type getApiFeatureFlagWorkedPropertyListResponse = (getApiFeatureFlagWorkedPropertyListResponseSuccess | getApiFeatureFlagWorkedPropertyListResponseError)

export const getGetApiFeatureFlagWorkedPropertyListUrl = (params?: GetApiFeatureFlagWorkedPropertyListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/worked-properties?${stringifiedParams}` : `/api/worked-properties`
}

export const getApiFeatureFlagWorkedPropertyList = async (params?: GetApiFeatureFlagWorkedPropertyListParams, options?: RequestInit): Promise<getApiFeatureFlagWorkedPropertyListResponse> => {
  
  return customFetch<getApiFeatureFlagWorkedPropertyListResponse>(getGetApiFeatureFlagWorkedPropertyListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type putApiFeatureFlagWorkedPropertiesUpdateResponse200 = {
  data: WorkedPropertyApiResource[]
  status: 200
}

export type putApiFeatureFlagWorkedPropertiesUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiFeatureFlagWorkedPropertiesUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiFeatureFlagWorkedPropertiesUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiFeatureFlagWorkedPropertiesUpdateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type putApiFeatureFlagWorkedPropertiesUpdateResponseSuccess = (putApiFeatureFlagWorkedPropertiesUpdateResponse200) & {
  headers: Headers;
};
export type putApiFeatureFlagWorkedPropertiesUpdateResponseError = (putApiFeatureFlagWorkedPropertiesUpdateResponse400 | putApiFeatureFlagWorkedPropertiesUpdateResponse401 | putApiFeatureFlagWorkedPropertiesUpdateResponse403 | putApiFeatureFlagWorkedPropertiesUpdateResponse404) & {
  headers: Headers;
};

export type putApiFeatureFlagWorkedPropertiesUpdateResponse = (putApiFeatureFlagWorkedPropertiesUpdateResponseSuccess | putApiFeatureFlagWorkedPropertiesUpdateResponseError)

export const getPutApiFeatureFlagWorkedPropertiesUpdateUrl = () => {


  

  return `/api/worked-properties`
}

export const putApiFeatureFlagWorkedPropertiesUpdate = async (updateWorkedPropertiesRequest: UpdateWorkedPropertiesRequest, options?: RequestInit): Promise<putApiFeatureFlagWorkedPropertiesUpdateResponse> => {
  
  return customFetch<putApiFeatureFlagWorkedPropertiesUpdateResponse>(getPutApiFeatureFlagWorkedPropertiesUpdateUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateWorkedPropertiesRequest,)
  }
);}


